import { get, isUndefined, size } from 'lodash';
import { chargerConfigurationStatus } from '../../screens/ChargersList/constants';
import uiLabelsPaths from './uiFieldLabelsDictionary';
import { fullPlazaNameLabel } from '../constants/naming';
import { arrayMove } from './ArrayUtils';
import { permissions } from '../constants/permissions';

const allPossibleColumnsArray = (config = {}) => [
  { id: 'time', label: 'Date/Time (UTC)', show: false },
  { id: uiLabelsPaths.p_type, label: get(config.ui_labels, uiLabelsPaths.p_type, 'Product Type'), show: false },
  { id: 'name', label: get(config.ui_labels, uiLabelsPaths.c_name, 'Charger Name'), show: false },
  { id: 'status', label: get(config.ui_labels, uiLabelsPaths.c_status, 'Charger Status'), show: false },
  {
    id: 'charger_state',
    label: get(config.ui_labels, uiLabelsPaths.connector_state, 'Present Charger State'),
    show: false,
  },
  { id: 'condition', label: get(config.ui_labels, uiLabelsPaths.c_condition, 'Charger Condition'), show: false },
  {
    id: 'warranty_end',
    label: get(config.ui_labels, uiLabelsPaths.c_warranty_end, 'Warranty End (UTC)'),
    show: false,
  },
  { id: 'country', label: get(config.ui_labels, uiLabelsPaths.c_country, 'Country'), show: false },
  { id: 'address', label: get(config.ui_labels, uiLabelsPaths.c_address, 'Address'), show: false },
  { id: 'contact', label: get(config.ui_labels, uiLabelsPaths.c_contact, 'Contact'), show: false },
  {
    id: 'product_serial_number',
    label: get(config.ui_labels, uiLabelsPaths.product_serial, 'Product Serial Number'),
    show: false,
  },
  { id: 'online', label: get(config.ui_labels, uiLabelsPaths.c_online, 'Online'), show: false },
  { id: 'fw_version', label: 'FW Version', show: false },
];

class ColumnsSortService {
  processDefaultSorting(columnsOrder, { config = {}, user = {} }) {
    let allColumns = allPossibleColumnsArray(config);
    const currentPermissions = get(user, 'currentPermissions', []);

    if (config.plazaAvailabilityMode === 'full' || config.plazaAvailabilityMode === 'partially') {
      allColumns.push({ id: 'plaza_uuid', label: fullPlazaNameLabel, show: false });
    }

    const isConfigurationVisibleByPermissions =
      currentPermissions.includes(permissions.SUPERVISOR) ||
      currentPermissions.includes(permissions.FULL_ACCESS) ||
      currentPermissions.includes(permissions.VIEW_CHARGER_CONFIGURATION);

    if (config.chargerDetails.configuration.show && isConfigurationVisibleByPermissions) {
      allColumns.push({
        id: chargerConfigurationStatus,
        label: get(config.ui_labels, uiLabelsPaths.configuration, 'Configuration'),
        show: false,
      });
    }

    const isSupervisor = currentPermissions.includes(permissions.SUPERVISOR);

    if (isSupervisor) {
      allColumns.push({ id: 'customer_id', label: 'Customer Name', show: false });
    }
    // change order of default columns according to saved order
    if (size(columnsOrder.data)) {
      for (const i in columnsOrder.data) {
        // to make columns from allPossibleColumns shown and change order with columnsOrder array
        const index = +i; // to convert string to number
        const column = columnsOrder.data[index]; // saved columns ['id', 'produc_type', ..]

        const curColIndex = allColumns.findIndex((col) => col.id === column); // index of column in allPossibleColumns

        if (curColIndex > -1) {
          // if we have column shown => show it and charger order
          const curCol = allColumns[curColIndex];

          curCol.show = true;
          allColumns = arrayMove(allColumns, curColIndex, index);
        }
      }
    }
    allColumns = allColumns.filter((n) => !isUndefined(n)); // to filter empty elements after array moving

    return allColumns;
  }
}

export default new ColumnsSortService();
